module.exports = __webpack_public_path__ + "static/media/IMG_9335.d9558dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/IMG_9335.jpg
// module id = 440
// module chunks = 0